module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Domenico Vale - Web developer & designer","short_name":"Domenico Vale's portfolio","start_url":"/","background_color":"#0E0D0D","theme_color":"#D52A24","display":"minimal-ui"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
